import React from 'react';
import Radium from 'radium';
import Checkbox from 'material-ui/Checkbox';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';
import Dotdotdot from 'react-dotdotdot';

import ListStyle from '../../ProjectList.styles';
import ProjectImageElement from '../../../ProjectImageElement';
import Styles from './ProjectListElement.styles';
import { getFileDownloadUrl } from '../../../../../helpers/fileHelpers';
import { IMAGE_SIZES } from '../../../../../constants';

class ProjectListElement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imageUrl: null,
    };
  }

  componentWillMount() {
    this.selectedCheckboxes = new Set();
  }

  componentDidMount() {
    this.getProjectImage();
  }

  getProjectImage() {
    const { favicon: { downloadURL = null, fullPath, name } = {} } = this.props || {};
    if (fullPath) {
      const path = fullPath.substring(0, fullPath.lastIndexOf('/'));
      getFileDownloadUrl(`${path}/${IMAGE_SIZES.THUMB_256}_${name}`)
        .then((res) => {
          this.setState({ imageUrl: res });
        })
        .catch(() => {
          this.setState({ imageUrl: downloadURL });
        });
    } else {
      this.setState({ imageUrl: downloadURL });
    }
  }

  render() {
    const { batchEdit, style, compressed, selected } = this.props;
    const selectedStyle = selected ? Styles.selectedStyle : {};

    return (
      <div
        role="row"
        tabIndex={this.props.index}
        style={[Styles.rowStyle, style, selectedStyle]}
        onClick={this.props.onClick}
      >
        {batchEdit && (
          <div style={[Styles.cellStyle, ListStyle.checkboxCell]}>
            <Checkbox
              checked={selected}
              style={Styles.checkbox.style}
              iconStyle={Styles.checkbox.icon}
              onCheck={() => this.onCheck()}
            />
          </div>
        )}
        <div style={[Styles.cellStyle, ListStyle.descriptionCell(batchEdit)]}>
          <div style={Styles.nameStyle}>{this.props.name}</div>
          <div style={Styles.descriptionStyle}>
            <Dotdotdot clamp={3}>{this.props.description}</Dotdotdot>
          </div>
        </div>
        <div style={[Styles.cellStyle, ListStyle.dateCell]}>{this.props.date}</div>
        <div style={[Styles.cellStyle]}>
          <div style={Styles.flexContainer}>
            <span>{this.props.size}</span>
          </div>
        </div>
        <div style={[Styles.cellStyle]}>
          {!compressed && (
            <div style={[Styles.imageFill]}>
              <ProjectImageElement
                alt=""
                imageUrl={this.state.imageUrl}
                style={{
                  maxHeight: '75px',
                  objectFit: 'scale-down',
                  objectPosition: 'center',
                }}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

ProjectListElement.propTypes = {
  onClick: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  date: PropTypes.string.isRequired,
  size: PropTypes.string,
  index: PropTypes.string.isRequired,
  batchEdit: PropTypes.bool.isRequired,
  compressed: PropTypes.bool.isRequired,
  selected: PropTypes.bool.isRequired,
  style: StylePropType,
};

ProjectListElement.defaultProps = {
  style: {},
  description: '',
  size: '',
  image: '',
  scenes: {},
};

export default Radium(ProjectListElement);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectList/ProjectListTable/ProjectListElement/ProjectListElement.js